import { axiosService } from "./axiosService";

const localeApi = {
    getLangs() {
        const url = '/locale-event/languages';
        return axiosService.get(url)
    },
    getMessages() {
        const url = '/locale/messages';
        return axiosService.get(url)
    },
}

export default localeApi;